/**
 * V217/V221 — roles que quien edita puede asignar en Usuarios:
 *  - un rol de administrador (#620) solo el titular (canAdmin);
 *  - un rol con permisos is_admin_only o de finanzas (`grants_restricted`) solo un SUPER_USER, no
 *    Recursos Humanos.
 * La pantalla solo oculta; el backend rechaza igual (403).
 */
export function assignableRole(
  r: { is_admin?: boolean; grants_restricted?: boolean },
  { canAdmin, isSuper }: { canAdmin: boolean; isSuper: boolean },
): boolean {
  return (canAdmin || !r.is_admin) && (isSuper || !r.grants_restricted);
}
